import { useCallback, useState } from "react";
import { debounce } from "../../../styles/styles";

export const useUniquenessCheck = (
  apiUrl,
  token,
  fieldName,
  customValidation
) => {
  const [state, setState] = useState({
    isChecking: false,
    isUnique: true,
    errorMessage: "",
  });

  const checkUniqueness = useCallback(
    debounce(async (value) => {
      if (!value || value.trim() === "") {
        setState({ isChecking: false, isUnique: true, errorMessage: "" });
        return;
      }

      setState((prev) => ({ ...prev, isChecking: true }));

      try {
        const response = await fetch(
          `${apiUrl}?${fieldName}=${encodeURIComponent(value)}`,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();

          // Use custom validation if provided, otherwise default check
          const exists = customValidation
            ? customValidation(data, value)
            : (data.results && data.results.length > 0) ||
              data.exists ||
              data.count > 0;

          setState({
            isChecking: false,
            isUnique: !exists,
            errorMessage: exists
              ? `This ${fieldName.replace(
                  "_",
                  " "
                )} is already in use. Please choose a different one.`
              : "",
          });
        } else {
          // If API error, assume valid to not block user
          setState({ isChecking: false, isUnique: true, errorMessage: "" });
        }
      } catch (error) {
        console.error("Error checking uniqueness:", error);
        setState({ isChecking: false, isUnique: true, errorMessage: "" });
      }
    }, 500),
    [apiUrl, token, fieldName, customValidation]
  );

  const reset = useCallback(() => {
    setState({ isChecking: false, isUnique: true, errorMessage: "" });
  }, []);

  return {
    ...state,
    checkUniqueness,
    reset,
  };
};
